export default __webpack_public_path__ + "static/media/modernSeoNextjs.760eec9f.md";